
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/_efro-oost/nieuws",
      function () {
        return require("private-next-pages/_sites/_efro-oost/nieuws/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/_efro-oost/nieuws"])
      });
    }
  